import React from "react";
import classNames from "classnames";
import { findByType } from "../../../sharedComponents/util/findByType";
import { Card as CardComponent } from "../../../sharedComponents/Accordion";
import { ToggleTemplate } from "./ToggleTemplate";
import * as styles from "./Accordion.module.scss";

const Card = () => null;
const Toggle = () => null;
const Panel = () => null;

Toggle.displayName = "TabsAndAccordionToggle";
Panel.displayName = "TabsAndAccordionPanel";

const renderCardComponent = (child, variant) => {
	const renderToggle = () => {
		const toggle = findByType(child.props.children, Toggle);
		if (!toggle) {
			return null;
		}

		return (
			<CardComponent.Toggle className={classNames(styles[`${variant}Toggle`])}>
				<ToggleTemplate variant={variant}>{toggle.props.children}</ToggleTemplate>
			</CardComponent.Toggle>
		);
	};

	const renderPanel = () => {
		const panel = findByType(child.props.children, Panel);
		if (!panel) {
			return null;
		}
		return (
			<CardComponent.Panel
				className={classNames(styles[`${variant}Panel`])}
				data-component-type="accordion">
				<div className={classNames(styles[`${variant}PanelBody`])}>{panel.props.children}</div>
			</CardComponent.Panel>
		);
	};
	return (
		<CardComponent eventKey={child.props.eventKey} className={classNames(styles[`${variant}Card`])}>
			{renderToggle()}
			{renderPanel()}
		</CardComponent>
	);
};

Card.Toggle = Toggle;
Card.Panel = Panel;

export default renderCardComponent;
export { renderCardComponent, Card };
